import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { NegativePressureWoundTherapyAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-negative-pressure-wound-therapy-slot',
    templateUrl: './negative-pressure-wound-therapy-slot.component.html',
    styleUrl: './negative-pressure-wound-therapy-slot.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NegativePressureWoundTherapySlotComponent implements SheetSlotComponentBase {

	@Input() action!: NegativePressureWoundTherapyAction;
	value = null;

	constructor() {
	}
}